import React from 'react';
import { FaUsers } from 'react-icons/fa';
import Tooltip from '../tooltip/Tooltip';
import GuestsSummary from './GuestsSummary';
import renderUtils from '../../helpers/renderUtils';

const ShortGuestsSummary = ({ className, guests, label = false, icon = true }) => {
  if (!guests) return null;

  const { guestsCount = 0, adults = 0, children = 0, infants = 0 } = guests;

  const tooltipText = `Dorośli: ${adults}, Dzieci: ${children}, Niemowlęta: ${infants}`;

  return (
    <div className={`d-flex align-items-center gap-1 cursor-pointer ${className}`}>
      <Tooltip tooltip={<GuestsSummary guests={guests} />}>
        {icon && <>
          <FaUsers size={18} />
          {' '}
        </>
        }
        <span>{guestsCount} {label ? renderUtils.getGuestLabel(guestsCount) : ''}</span>
      </Tooltip>
    </div>
  );
};

export default ShortGuestsSummary;
